import "core-js/modules/es.array.push.js";
import { defineComponent, ref, computed, watch, openBlock, createElementBlock, createElementVNode, createTextVNode, toDisplayString, createVNode, unref, Fragment, renderList, normalizeClass, createCommentVNode, withCtx, normalizeStyle } from "vue";
import { CdrSelect, CdrLink, CdrTable } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  class: "size-guide-modal"
};
const _hoisted_2 = {
  class: "size-guide-modal__instructions"
};
const _hoisted_3 = {
  class: "size-guide-modal__product-title"
};
const _hoisted_4 = {
  class: "size-guide-modal__select-container"
};
const _hoisted_5 = {
  class: "size-guide-modal__select-feet"
};
const _hoisted_6 = {
  class: "size-guide-modal__select-inches"
};
const _hoisted_7 = {
  key: 0,
  class: "size-guide-modal__suggested-size-container"
};
const _hoisted_8 = {
  key: 0,
  class: "size-guide-modal__suggested-size-callout-container"
};
const _hoisted_9 = {
  class: "size-guide-modal__suggested-size-results",
  "data-ui": "suggested-size-results"
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = {
  key: 0,
  class: "size-guide-modal__table-seeker-row",
  "aria-hidden": "true"
};
const _hoisted_14 = {
  class: "size-guide-modal__cell"
};
const _hoisted_15 = {
  class: "size-guide-modal__header",
  "data-ui": "size-guide-col"
};
const _hoisted_16 = {
  class: "size-guide-modal__cell"
};
const _hoisted_17 = {
  class: "size-guide-modal__height-min",
  "aria-hidden": "true"
};
const _hoisted_18 = {
  class: "pdp-sr-only"
};
const _hoisted_19 = {
  class: "size-guide-modal__height-max",
  "aria-hidden": "true"
};
const _hoisted_20 = {
  class: "size-guide-modal__talk-to-an-expert"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SizeFinderModal",
  props: {
    productTitle: {},
    sizeGuide: {},
    sizeFinderSelectedSize: {
      default: () => ({
        feet: "",
        inches: ""
      })
    },
    sizeFinderResults: {
      default: () => []
    },
    isHeightSelected: {
      type: Boolean,
      default: false
    },
    sizeFinderSeekerHeight: {
      default: 0
    }
  },
  emits: ["feetSelectChange", "inchesSelectChange", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const seekerLine = ref(null);
    const props = __props;
    const emit = __emit;
    const feetRange = computed(() => {
      const options = [];
      for (let i = 4; i <= 7; i += 1) {
        options.push(i.toString());
      }
      return options;
    });
    const inchRange = computed(() => [...Array(12).keys()].map((i) => i.toString()));
    const absMinHeightInches = computed(() => props.sizeGuide[0].minHeightInches);
    const absMaxHeightInches = computed(() => props.sizeGuide[props.sizeGuide.length - 1].maxHeightInches);
    const sizeBarGridTemplateCols = computed(() => absMaxHeightInches.value - absMinHeightInches.value);
    const seekerGridCol = computed(() => props.isHeightSelected ? props.sizeFinderSeekerHeight - absMinHeightInches.value + 1 : 1);
    const sizeFinderResultsToDisplay = computed(() => {
      if (props.sizeFinderResults.length > 1) {
        const multipleSizeFinderResults = [];
        for (let index = 0; index < props.sizeFinderResults.length; index += 1) {
          multipleSizeFinderResults.push(props.sizeFinderResults[index]);
          if (index !== props.sizeFinderResults.length - 1) {
            multipleSizeFinderResults.push("or");
          }
        }
        return multipleSizeFinderResults;
      }
      return props.sizeFinderResults;
    });
    watch(seekerGridCol, () => {
      if (props.isHeightSelected && props.sizeFinderResults.length && seekerLine.value) {
        seekerLine.value.style.display = "none";
        seekerLine.value.offsetHeight;
        seekerLine.value.style.display = "block";
      }
    });
    function handleFeetSelectChange(event) {
      emit("feetSelectChange", parseInt(event.target.value, 10));
    }
    function handleInchesSelectChange(event) {
      emit("inchesSelectChange", parseInt(event.target.value, 10));
    }
    function tableRowEmphasizeClass({
      size
    }) {
      if (!props.isHeightSelected) {
        return "";
      }
      if (props.sizeFinderResults.length) {
        return props.sizeFinderResults.includes(size) ? "size-guide-modal__table-row--emphasize" : "size-guide-modal__table-row--deemphasize";
      }
      return "size-guide-modal__table-row--deemphasize";
    }
    function percentageBarGridCol(size) {
      const gridColStart = size.minHeightInches - absMinHeightInches.value + 1;
      const gridColEnd = size.maxHeightInches - absMinHeightInches.value + 1;
      return `${gridColStart} / ${gridColEnd}`;
    }
    function percentageBarOverlapClass({
      minHeightInches,
      maxHeightInches
    }) {
      let barOverlapClass = "";
      if (props.sizeFinderSeekerHeight === minHeightInches) {
        barOverlapClass = "size-guide-modal__percentage-bar-overlap--left";
      } else if (props.sizeFinderSeekerHeight === maxHeightInches) {
        barOverlapClass = "size-guide-modal__percentage-bar-overlap--right";
      }
      return barOverlapClass;
    }
    function handleFindStore(event) {
      emit("metricsClick", {
        linkName: "bike-size_shop in store",
        link: "/stores/map",
        event
      });
    }
    return (_ctx, _cache) => {
      return _ctx.sizeGuide.length ? (openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("p", _hoisted_2, [_cache[2] || (_cache[2] = createTextVNode(" Enter your height and we’ll help find your ")), createElementVNode("span", _hoisted_3, toDisplayString(_ctx.productTitle), 1), _cache[3] || (_cache[3] = createTextVNode(" size. "))]), createElementVNode("div", _hoisted_4, [createElementVNode("div", _hoisted_5, [createVNode(unref(CdrSelect), {
        label: "Feet",
        prompt: "Select",
        required: "",
        "model-value": _ctx.sizeFinderSelectedSize.feet,
        options: feetRange.value,
        "data-ui": "feet-select",
        onChange: handleFeetSelectChange
      }, null, 8, ["model-value", "options"])]), createElementVNode("div", _hoisted_6, [createVNode(unref(CdrSelect), {
        label: "Inches",
        prompt: "Select",
        required: "",
        "model-value": _ctx.sizeFinderSelectedSize.inches,
        options: inchRange.value,
        "data-ui": "inches-select",
        onChange: handleInchesSelectChange
      }, null, 8, ["model-value", "options"])])]), _ctx.isHeightSelected ? (openBlock(), createElementBlock("div", _hoisted_7, [_ctx.sizeFinderResults.length >= 1 ? (openBlock(), createElementBlock("h2", _hoisted_8, [_cache[4] || (_cache[4] = createElementVNode("span", {
        class: "size-guide-modal__suggested-size-callout"
      }, "We suggest", -1)), createElementVNode("div", _hoisted_9, [(openBlock(true), createElementBlock(Fragment, null, renderList(sizeFinderResultsToDisplay.value, (size, index) => {
        return openBlock(), createElementBlock("span", {
          key: index,
          class: normalizeClass(size === "or" ? "size-guide-modal__suggested-size-spacer" : "size-guide-modal__suggested-size")
        }, toDisplayString(size), 3);
      }), 128))])])) : createCommentVNode("", true), _ctx.sizeFinderResults.length === 1 ? (openBlock(), createElementBlock("p", _hoisted_10, " Based on your height and this bike’s measurements, this size is a good fit for you. ")) : _ctx.sizeFinderResults.length > 1 ? (openBlock(), createElementBlock("p", _hoisted_11, " In general, sizing up offers a relaxed, upright ride. Sizing down provides more efficiency and performance. ")) : (openBlock(), createElementBlock("p", _hoisted_12, [_cache[6] || (_cache[6] = createTextVNode(" Unfortunately, this bike doesn’t come in a size recommended for your height. For help with unique sizing needs, talk to an REI cycle expert ")), createVNode(unref(CdrLink), {
        href: "/stores/map",
        onClick: _cache[0] || (_cache[0] = ($event) => handleFindStore($event))
      }, {
        default: withCtx(() => _cache[5] || (_cache[5] = [createTextVNode(" in a store near you ")])),
        _: 1,
        __: [5]
      }), _cache[7] || (_cache[7] = createTextVNode(". "))]))])) : createCommentVNode("", true), createVNode(unref(CdrTable), {
        class: "size-guide-modal__table",
        "aria-label": "size chart",
        "full-width": ""
      }, {
        default: withCtx(() => [createElementVNode("tbody", null, [_ctx.isHeightSelected && _ctx.sizeFinderResults.length ? (openBlock(), createElementBlock("tr", _hoisted_13, [_cache[9] || (_cache[9] = createElementVNode("th", {
          class: "size-guide-modal__header"
        }, null, -1)), createElementVNode("td", _hoisted_14, [createElementVNode("div", {
          class: "size-guide-modal__table-seeker-wrapper",
          style: normalizeStyle({
            "grid-template-columns": `repeat(${sizeBarGridTemplateCols.value}, 1fr)`
          })
        }, [createElementVNode("div", {
          class: "size-guide-modal__table-seeker",
          style: normalizeStyle({
            "grid-column": `${seekerGridCol.value}`
          })
        }, [createElementVNode("div", {
          ref_key: "seekerLine",
          ref: seekerLine,
          class: "size-guide-modal__table-seeker-line",
          "data-ui": "seeker-line"
        }, _cache[8] || (_cache[8] = [createElementVNode("div", {
          class: "size-guide-modal__table-seeker-label"
        }, " You ", -1)]), 512)], 4)], 4)])])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sizeGuide, (size) => {
          return openBlock(), createElementBlock("tr", {
            key: size.size,
            class: normalizeClass(`size-guide-modal__table-row ${tableRowEmphasizeClass(size)}`),
            "data-ui": "size-guide-table-row"
          }, [createElementVNode("th", _hoisted_15, toDisplayString(size.size), 1), createElementVNode("td", _hoisted_16, [createElementVNode("div", {
            class: "size-guide-modal__percentage-wrapper",
            style: normalizeStyle({
              "grid-template-columns": `repeat(${sizeBarGridTemplateCols.value}, 1fr)`
            })
          }, [createElementVNode("div", {
            class: normalizeClass(`size-guide-modal__percentage-bar ${percentageBarOverlapClass(size)}`),
            style: normalizeStyle({
              "grid-column": `${percentageBarGridCol(size)}`
            }),
            "data-ui": "size-guide-percentage-bar"
          }, [createElementVNode("div", _hoisted_17, toDisplayString(size.minFeetAndInches.feet) + "'" + toDisplayString(size.minFeetAndInches.inches) + '" ', 1), createElementVNode("p", _hoisted_18, [_ctx.sizeFinderResults.length === 1 && _ctx.sizeFinderResults.includes(size.size) ? (openBlock(), createElementBlock(Fragment, {
            key: 0
          }, [createTextVNode(" Suggested size for your height. ")], 64)) : _ctx.sizeFinderResults.length > 1 && _ctx.sizeFinderResults.includes(size.size) ? (openBlock(), createElementBlock(Fragment, {
            key: 1
          }, [createTextVNode(" Suggested size " + toDisplayString(_ctx.sizeFinderResults.indexOf(size.size) + 1) + " of " + toDisplayString(_ctx.sizeFinderResults.length) + ". ", 1)], 64)) : createCommentVNode("", true), createTextVNode(" Fits people from " + toDisplayString(size.minFeetAndInches.feet) + " feet " + toDisplayString(size.minFeetAndInches.inches) + " inches tall to " + toDisplayString(size.maxFeetAndInches.feet) + " feet " + toDisplayString(size.maxFeetAndInches.inches) + " inches tall. ", 1)]), createElementVNode("div", _hoisted_19, toDisplayString(size.maxFeetAndInches.feet) + "'" + toDisplayString(size.maxFeetAndInches.inches) + '" ', 1)], 6)], 4)])], 2);
        }), 128))])]),
        _: 1
      }), _cache[13] || (_cache[13] = createElementVNode("h2", {
        class: "size-guide-modal__between-sizes"
      }, " Between sizes? Long legs? Short arm reach? ", -1)), createElementVNode("p", _hoisted_20, [_cache[11] || (_cache[11] = createTextVNode(" Height-based sizing works for most people. For a personalized fit, talk to an REI cycle expert ")), createVNode(unref(CdrLink), {
        href: "/stores/map",
        onClick: _cache[1] || (_cache[1] = ($event) => handleFindStore($event))
      }, {
        default: withCtx(() => _cache[10] || (_cache[10] = [createTextVNode(" in a store near you ")])),
        _: 1,
        __: [10]
      }), _cache[12] || (_cache[12] = createTextVNode(". "))])])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SizeFinderModal2.mjs.map
